// src/redux/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

/**
 * Safely parse JSON stored in localStorage.
 * • If the key is missing, the string "undefined", or corrupt JSON → return fallback.
 * • Otherwise return the parsed value.
 */
const safeParse = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === 'undefined') return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const initialState = {
  adminLogin: safeParse('adminLogin', false), // boolean
  user:       safeParse('user', null),        // object | null
  authToken:  localStorage.getItem('authToken') ?? null, // plain string token
  sessionExpired: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginAsAdmin(state, action) {
      state.adminLogin = true;
      state.user       = action.payload.user;
      state.authToken  = action.payload.token;

      // ALWAYS store JSON‑safe strings
      localStorage.setItem('adminLogin', JSON.stringify(true));          // "true"
      localStorage.setItem('user',       JSON.stringify(action.payload.user));
      localStorage.setItem('authToken',  action.payload.token);
    },

    logout(state) {
      state.adminLogin = false;
      state.user       = null;
      state.authToken  = null;

      localStorage.removeItem('adminLogin');
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');
    },

    updateUserOrgMode(state, action) {
      if (state.user) {
        state.user.orgStructureMode = action.payload;
        state.user.orgModeLocked = true;
        localStorage.setItem('user', JSON.stringify(state.user));
      }
    },

    setSessionExpired(state, action) {
      state.sessionExpired = action.payload;
    }
  }
});

export const { loginAsAdmin, logout, updateUserOrgMode, setSessionExpired } = authSlice.actions;
export default authSlice.reducer;
